import { Link } from "react-router-dom";

interface ContactCTATexts {
  title: string;
  cta_button: string;
  link_url: string;
}

interface ContactCTAProps {
  texts?: ContactCTATexts;
}

export default function ContactCTA({ texts }: ContactCTAProps) {

  return (
    <section className="py-6 md:py-10 px-4 md:px-6 lg:px-8 bg-white">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-5 md:mb-7">
          {texts ? texts.title : ""}
        </h2>

        <Link
          to={texts ? texts.link_url : "/kontakt"}
          className="inline-flex items-center gap-2 px-8 py-3 md:px-10 md:py-4 font-heading text-sm md:text-base font-semibold text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {texts ? texts.cta_button : ""}
          <i className="ri-arrow-right-line" />
        </Link>
      </div>
    </section>
  );
}